export default __webpack_public_path__ + "static/media/mythicCircusIcon.8450e27a.png";